export default __webpack_public_path__ + "locales/cs/JavascriptSdk.json?hash=950efcd928edc9c2ae979e2d1ebe6e34";